(function() { module.exports = window["AFFWP"]["portal"]["portalForm"]; }());